import * as orders from './orders';
import * as stock from './stock';
import * as requestsDevice from './RequestsInstallationDevice';

const reducers = {
  ...orders,
  ...requestsDevice,
  ...stock,
};

export default reducers;
